export const POPOVER = {
  TOOLTIP_MAX_WIDTH: 300,
  MENU_MAX_WIDTH: 300,
  TRIGGER_TYPE: { CLICK: "click", HOVER: "hover", FOCUS: "focus" },
  STRATEGY: { ABSOLUTE: "absolute", FIXED: "fixed" },
  POSITIONS: {
    TOP: "top",
    TOP_LEFT: "top-start",
    TOP_RIGHT: "top-end",
    RIGHT: "right",
    BOTTOM: "bottom",
    LEFT: "left",
    BOTTOM_LEFT: "bottom-start",
    BOTTOM_RIGHT: "bottom-end",
  },
};